/**
 * Check if the YouTube URL is valid
 */
export const isValidYoutubeUrl = (url: string): boolean => {
    const youtubeIdRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|shorts\/)?([a-zA-Z0-9_-]{11})(\?.*)?$/
  
    return youtubeIdRegex.test(url)
  }
  
  /**
   * Get the YouTube thumbnail URL
   * @param youtubeUrl - The YouTube video URL
   * @returns - The thumbnail URL
   */
  export const getYoutubeThumbnailUrl = (youtubeUrl: string): string => {
    if (!youtubeUrl) {
      return ''
    }
  
    const youtubeIdRegex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/|shorts\/)?([a-zA-Z0-9_-]{11})/
  
    const youtubeId = youtubeUrl.match(youtubeIdRegex)?.[1]
  
    return `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`
  }
  
  /**
   * Handle logic for setting the YouTube thumbnail
   * @param imgSourceType - The image source type
   * @param value - The current cell value
   * @param imgSourceYoutube - The YouTube URL if the source type is YouTube
   * @returns The YouTube thumbnail URL or the provided value
   */
  export const handleImageSource = (imgSourceType: string, value: string, imgSourceYoutube?: string): string => {
    if (imgSourceType === 'youtube') {
      if (!imgSourceYoutube || !isValidYoutubeUrl(imgSourceYoutube)) {
        return getYoutubeThumbnailUrl('') // Return default YouTube thumbnail
      }
      return getYoutubeThumbnailUrl(imgSourceYoutube) // Return the correct YouTube thumbnail
    }
  
    return value?.toString() || '' // Default behavior for non-YouTube images
  }
  